// extracted by mini-css-extract-plugin
export var active = "_1q-d";
export var blink = "_1q-e";
export var container = "_1q-5";
export var controls = "_1q-0";
export var controlsRight = "_1q-1";
export var fakeCursor = "_1q-c";
export var hidden = "_1q-b";
export var quillContainerSmall = "_1q-7";
export var quillEditor = "_1q-6";
export var quillEditorSmall = "_1q-8";
export var quillFormatButtons = "_1q-a";
export var quillToolbar = "_1q-9";
export var removePadding = "_1q-2";
export var state = "_1q-3";
export var stateTitle = "_1q-4";